module.exports = __webpack_public_path__ + "img/516ad9d.svg";